import React from 'react';

const Footer=()=>{
    return(
        <div>
            <footer className="bg-light text-center">
                <p>&copy; 2020 Mian Technicals. All rights reserved | Terms & conditions apply</p>
            </footer>
        </div>
    )
}
export default Footer;